import type { PropsWithChildren } from "react";

import { styled } from "@linaria/react";

import { withTheme } from "../theme/GalaxyTheme";
import type { PropsWithTheme } from "../theme/types";

const StyledSelectable = withTheme(styled.span<PropsWithTheme>`
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
`);

const Selectable = ({ children }: PropsWithChildren) => {
  return <StyledSelectable>{children}</StyledSelectable>;
};

export default Selectable;
